/**
 * The element that scrolls in the authenticated app. The window does not:
 * the app sits in a frame below the banners, and this element inside it
 * scrolls. Anything that used to read or listen to the window's scroll reads
 * this element instead.
 */
export const APP_SCROLL_ID = 'app-scroll'

export function appScrollElement(): HTMLElement | null {
  return document.getElementById(APP_SCROLL_ID)
}
